<template lang="pug">
v-row.leg-configuration
  v-col(
    v-for="carrier in filterCarriers()",
    cols="2"
  )
    //- Base v-model behavior from vuetify makes it posible to handle an array with multiple checkboxes
    //- https://vuetifyjs.com/en/components/checkboxes/#model-as-array
    v-checkbox(
      v-model="selected",
      :label="carrier.name",
      :value="carrier.id",
    )
</template>

<script>
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: {
    carriers: {
      type: Array,
      default: () => ([]),
    },
    legTransportMode: {
      type: String,
      default: () => "",
    },
    value: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    selected: []
  }),
  watch: {
    selected(newSelection) {
      this.$emit('input', newSelection);
    },
  },
  methods: {
    filterCarriers() {
      if (_.isEmpty(this.carriers) || _.isEmpty(this.legTransportMode)) return [];
      if (!this.legTransportMode) return this.carriers;
      return _.filter(this.carriers, ['typeOfTransport', this.legTransportMode]);
    },
  },
  created() {
    this.filterCarriers();
    this.selected = this.value;
  },
}
</script>
